export type DraftKind = 'draft' | 'scheduled';

export interface DraftStatus {
  kind: DraftKind;
  label: string;    // short text for card badges
  heading: string;  // bold text in the post hero
  detail: string;   // explanation (hero + tooltip)
}

const shortDate: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' };
const longDate: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
const longDateTime: Intl.DateTimeFormatOptions = {
  ...longDate,
  hour: 'numeric',
  minute: '2-digit',
  timeZoneName: 'short', // "EST" / "EDT" so the hour is unambiguous
};

export function getDraftStatus(
  draft: boolean,
  date: string | null | undefined,
  now: Date = new Date()
): DraftStatus | null {
  if (draft) {
    return {
      kind: 'draft',
      label: 'Draft · Not scheduled',
      heading: 'Draft · Not scheduled',
      detail: 'This post will not go live until the draft flag is turned off. Only Marketing can see it.',
    };
  }

  if (date) {
    const publishAt = new Date(date);
    if (!isNaN(publishAt.getTime()) && publishAt > now) {
      return {
        kind: 'scheduled',
        label: `Draft · Scheduled for ${publishAt.toLocaleDateString('en-US', shortDate)}`,
        heading: `Draft · Scheduled for ${publishAt.toLocaleDateString('en-US', longDate)}`,
        detail: `Goes live ${publishAt.toLocaleString('en-US', longDateTime)}. Not visible to the public until then.`,
      };
    }
  }

  return null;
}